import React, { memo } from 'react'
import ControlledCheckbox from 'transfix-form/components/ControlledCheckbox'
import ControlledSelect from 'transfix-form/components/ControlledSelect'
import Typography from 'transfix-ui/core/Typography'
import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import { YEARS_OPTIONS } from 'apps/marketplace/utils/constants/graphqlEquipment'
import { useCreateShipmentFormContext } from '../../../context'

export interface ITrailerQualityFormSectionProps {}

const TrailerQualityFormSection = memo<ITrailerQualityFormSectionProps>(() => {
  /**
   * Form Context
   */
  const { control } = useCreateShipmentFormContext()

  return (
    <div>
      <Typography variant='subtitle1'>Trailer Quality</Typography>
      <div>
        <ControlledSelect
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.not_older_than}`}
          SelectProps={{
            label: 'Not older than',
            dataTest: 'not-older-than-field',
            options: YEARS_OPTIONS,
          }}
        />
      </div>
      <div>
        <ControlledCheckbox
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.food_grade}`}
          CheckboxProps={{
            label: 'Food Grade',
            dataTest: 'food-grade-field',
          }}
        />
      </div>
    </div>
  )
})

export default TrailerQualityFormSection
